import React from 'react';
import data from "../data/teaching.json";
import './Education.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faMicrochip, faDatabase } from '@fortawesome/free-solid-svg-icons';

const teachingIcons = {
  'CSE 115': faCode,
  'FSE 100': faMicrochip,
  'CSE 412': faDatabase,
};

function getTeachingIcon(title) {
  const key = Object.keys(teachingIcons).find(k => title.includes(k));
  return key ? teachingIcons[key] : faCode;
}

const Education = () => {
  return (
    <div className="education-container">
      <div className="section-header">
        <h2 className="Title_research">Teaching</h2>
      </div>
      
      {data.Instructing.map((course, index) => (
        <div key={index} className="course-item">
          <span className="course-title">
            <FontAwesomeIcon icon={getTeachingIcon(course.Title)} className="teaching-icon" />
            {course.Title} - {course.Role}
          </span>
          <span className="course-company">{course.Company}</span>
          <div className="course-links">
            {course.Details.map((detail, idx) => (
              <a 
                key={idx}
                className="course-link"
                target="_blank"
                rel="noopener noreferrer"
                href={detail.detail}
              >
                Course Website
              </a>
            ))}
          </div>
        </div>
      ))}
      
      {/* {data.Teaching.map((course, index) => (
        <div key={index} className="course-item">
          <span className="course-title">
            <FontAwesomeIcon icon={getTeachingIcon(course.Title)} className="teaching-icon" />
            {course.Title} - {course.Role}
          </span>
          <span className="course-company">{course.Company}</span>
          <div className="course-links">
            {course.Details && course.Details.map((detail, idx) => (
              <a 
                key={idx}
                className="course-link"
                target="_blank"
                rel="noopener noreferrer"
                href={detail.detail}
              >
                Course Website
              </a>
            ))}
          </div>
        </div>
      ))} */}
    </div>
  );
};

export default Education;